import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import type { Spotlight } from '@hellenica/shared';

export default function SpotlightList() {
  const { data, isLoading } = useQuery<{ spotlights: Spotlight[]; total: number }>({
    queryKey: ['spotlights'],
    queryFn: () => api.get('/v1/admin/spotlights'),
  });

  if (isLoading) return <div className="animate-pulse">Loading...</div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-2xl font-semibold text-gray-900">Spotlight</h1>
        <Link to="/spotlight/new" className="px-4 py-2 bg-brand-bronze text-white rounded-md hover:bg-brand-bronze/90">
          New Spotlight
        </Link>
      </div>

      <div className="bg-white shadow rounded-lg divide-y">
        {data?.spotlights.map((spotlight) => (
          <Link key={spotlight.id} to={`/spotlight/${spotlight.id}`} className="block p-6 hover:bg-gray-50">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-medium text-gray-900">{spotlight.title}</h3>
                <p className="text-sm text-gray-500 mt-1">{spotlight.excerpt}</p>
              </div>
              <div className="flex items-center gap-4">
                {spotlight.featured && (
                  <span className="px-2 py-1 bg-brand-bronze/10 text-brand-bronze text-xs rounded-full">Featured</span>
                )}
                <span className={`px-2 py-1 text-xs rounded-full ${spotlight.status === 'published' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`}>
                  {spotlight.status}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
